import { useState } from 'react'
import {
  DEFAULT_EXECUTIVE_FILTERS,
  isExecutiveCampaignId,
  isExecutiveInstitutionId,
  isExecutivePeriodId,
  isExecutiveStatusId,
  type ExecutiveFiltersState,
} from '../lib/executive-filters'

type ExecutiveFiltersController = {
  filters: ExecutiveFiltersState
  setPeriod: (value: string) => void
  setInstitution: (value: string) => void
  setCampaign: (value: string) => void
  setStatus: (value: string) => void
}

export function useExecutiveFilters(): ExecutiveFiltersController {
  const [filters, setFilters] = useState<ExecutiveFiltersState>(DEFAULT_EXECUTIVE_FILTERS)

  return {
    filters,
    setPeriod: (value) => {
      if (isExecutivePeriodId(value)) {
        setFilters((current) => ({ ...current, period: value }))
      }
    },
    setInstitution: (value) => {
      if (!isExecutiveInstitutionId(value)) {
        return
      }
      setFilters((current) => {
        if (current.institution === value) {
          return current
        }
        return { ...current, institution: value, campaign: 'all' }
      })
    },
    setCampaign: (value) => {
      if (isExecutiveCampaignId(value)) {
        setFilters((current) => ({ ...current, campaign: value }))
      }
    },
    setStatus: (value) => {
      if (isExecutiveStatusId(value)) {
        setFilters((current) => ({ ...current, status: value }))
      }
    },
  }
}
